import config from '../../config';

export class GoogleAnalyticsService {
  public static initialize() {
    gtag('config', config.googleAnalyticsId);
  }
}
